export const APP_NAME = 'ventas-digitales-v2';
